export default __webpack_public_path__ + "static/media/simplifio_logo.a6ff49b8.svg";